//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import BackendServices from "@/services/backend-services";
import { required } from "@/utils/validations.js";
import { noValidation } from "@/utils/validations.js";
import { checkPermission } from "@/utils/permissions-validations.js";

export default {
  name: "TraitsTab",
  props: ["value"],
  components: {},
  mounted: function () {
    this.validateData();
  },
  data: () => ({
    validForm: false,
    hierarchyLevels: [],
    hierarchyLevelElements: [],
  }),
  computed: {
    isNew: function () {
      return this.value.id == null || this.value.id == undefined;
    },
    user_admin: function () {
      return checkPermission("system_settings");
    },
  },
  methods: {
    required,
    noValidation,
    hierarchyValidation: function (index) {
      if (!index) {
        return this.required("Campo obrigatório");
      } else {
        return this.noValidation();
      }
    },
    validateData: function () {
      this.$refs.form.validate().then((success) => {
        if (success) {
          this.validForm = true;
          this.$emit("form-valid", this.validForm);
        } else {
          this.validForm = false;
          this.$emit("form-invalid", this.validForm);
        }
      });
    },
    updateData: function () {
      this.$emit("value", this.value);
    },
    getHierarchyList(index, level, parentId) {
      if (level) {
        BackendServices.getProductHierarchyLevelElements(
          level.id,
          parentId
        ).then(({ data }) => {
          this.hierarchyLevelElements[index] = data;
          this.value.hierarchy.splice(
            index,
            this.value.hierarchy.length - index
          );
          for (
            let i = index;
            i < this.hierarchyLevelElements.length;
            i = i + 1
          ) {
            this.hierarchyLevelElements.splice(i, 1, []);
          }
          this.value.hierarchy.push({
            id: null,
            name: null,
            level_id: this.hierarchyLevels[index].id,
            parent_id: this.value.hierarchy[index - 1].id,
          });
        });
        this.updateData();
      }
    },
  },
  watch: {
    "value.hierarchy": {
      immediate: true,
      deep: true,
      handler: function () {
        BackendServices.getProductHierarchyLevels().then(({ data }) => {
          this.hierarchyLevels = data;
          if (!this.hierarchyLevelElements.length) {
            this.hierarchyLevelElements = new Array(
              this.hierarchyLevels.length
            ).fill([]);
          }
          for (let i = 0; i < this.value.hierarchy.length; i++) {
            BackendServices.getProductHierarchyLevelElements(
              this.hierarchyLevels[i].id,
              i > 0 ? this.value.hierarchy[i - 1].id : null
            ).then((response) => {
              this.hierarchyLevelElements.splice(i, 1, response.data);
            });
          }
        });
      },
    },
  },
};
